import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import type { DashboardPaymentTypeEnum } from "@/enums"
import type { AlterPasswordSchemaProps } from "@/schemas/alter-password"
import type { FirstLoginSchemaProps } from "@/schemas/first-login"
import type {
  DashboardPaymentType,
  DashboardSearchParamsType,
} from "@/types/dashboard"
import { StringHelper } from "@/utils"
export const login = async (body: LoginRequestType) => {
  const { data } = await api.post<LoginResponseType>(
    ENDPOINTS.LOGIN,
    body
  )
  return data
}
export const forgotPassword = async (email: string) => {
  const url = `${ENDPOINTS.FORGOT_PASSWORD}/${email}`
  const { data } = await api.post(url)
  return data
}
export const whitelabels = async () => {
  const { data } = await api.get<WhitelabelsResponseType>(
    ENDPOINTS.WHITE_LABELS
  )
  return data
}
export const dashboardPayment = async (
  params: DashboardSearchParamsType<DashboardPaymentTypeEnum>
) => {
  const queryString =
    StringHelper.objectToQueryString(params)
  const url = `${ENDPOINTS.DASHBOARD_PAYMENT}?${queryString}`
  const { data } = await api.get<DashboardPaymentType>(url)
  return data
}
export const forgotPasswordConfirm = async (
  body: AlterPasswordSchemaProps
) => {
  const { data } = await api.post(
    ENDPOINTS.FORGOT_PASSWORD_CONFIRM,
    body
  )
  return data
}
export const firstLogin = async (
  body: FirstLoginSchemaProps
) => {
  const { data } = await api.post(
    ENDPOINTS.FIRST_LOGIN,
    body
  )
  return data
}
export const subscriptionDownloadLetterPDF = async (
  subscriptionId: string,
  billingCycle: number
) => {
  const url = `${ENDPOINTS.SUBSCRIPTION}/${subscriptionId}/cycle/${billingCycle}/download_letter`
  const { data } = await api.get(url, {
    responseType: "blob",
  })
  return data
}
